module.exports = __webpack_public_path__ + "img/cannotAccess.b3e1a1fa.png";